export default __webpack_public_path__ + "static/discover-7fc7afa01bd87ffaaeae3a631edbfc0c.svg";